import React from 'react';

import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../../AbstractElements';
import PricingDetailCard from './PricingDetailCard';
import SimplePricingCard from './SimplePricingCard';

const PricingCardContainer = () => {
  return (
    <Container fluid={true}>
      <Breadcrumbs justify='end' pageTitle='Pricing' parent='Ecommerce' title='Pricing' />
      <Row>
        <SimplePricingCard />
        <PricingDetailCard />
      </Row>
    </Container>
  );
};

export default PricingCardContainer;
